import type { Option } from 'types'
import { routeList } from 'routes/routeList'

export const reportPageTabsNavOptions: Option[] = [
  { text: 'За тематикою', key: routeList.reportByTheme },
  { text: 'За ключовим словом', key: routeList.reportByKeywords },
  { text: 'По B2B сегменту', key: routeList.reportByB2b },
  // { text: 'Вибірка даних', key: routeList.reportByData },
]
